import config from '@/config'

const search = new URLSearchParams(window.location.search)
const currentDate = search.get('currentDate')

export const getCurrentOrMockedDate = () => {
    if (config.isProduction || !currentDate) {
        return new Date()
    }

    const mockedDate = new Date(currentDate)
    // eslint-disable-next-line no-console
    console.info('Using mocked current date: ', mockedDate)

    return mockedDate
}
